import React, { useEffect, useState } from 'react'
import MeetOurTeamStyles from './MeetOurTeamStyles.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import axios from 'axios';
import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';


// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'

import DeleteConformation from '../DeleteConformation/DeleteConformation';

const MeetOurTeam = () => {

    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();



    const [data, setData] = useState([])

    const getTeamData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSADMIN}/team/getAllTeamDetails`
            )
            setData(res.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getTeamData()
    }, [])




    const handleDeleteTeam = async () => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_COSMOSADMIN}/team/deleteById/${tempData.teamImageId}`
            ).then((res) => {
                showToast("success", "Our Team Delete Successfully");
                handleDeleteModal();
                getTeamData();
            })


            
            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }



    const [deleteModal, setDeleteModal] = useState(false);

    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }


    return (
        <>
            <Toast />
            <useBackdrop />
            <div className={MeetOurTeamStyles.meetourteamMain}>
                <div className={MeetOurTeamStyles.meetourteamContent}>
                    <div className={MeetOurTeamStyles.meetourteamHeader}>
                        <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' }} >
                            Meet our team
                        </Typography>
                        <Link to='/addteammember'>
                            <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Team</Button>
                        </Link>
                    </div>
                    <Box className={MeetOurTeamStyles.meetourteamComponent}>
                        <div className={MeetOurTeamStyles.meetourteamComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={MeetOurTeamStyles.meetourteamComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data?.map((member) =>
                        <Box className={MeetOurTeamStyles.meetourteamComponent}>
                            <div className={MeetOurTeamStyles.meetourteamComponentLeft}>
                                <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                    {member?.team?.teammateName}
                                </Typography>
                            </div>
                            <div className={MeetOurTeamStyles.meetourteamComponentRight}>
                                <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                    {member?.team?.date}
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                    <Link to={`/teammember/${member?.teamImageId}`} state={member}>
                                        <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </Link>
                                    <IconButton disableRipple onClick={() => handleDeleteModal(member)}>
                                        <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                    </IconButton>
                                </Typography>
                            </div>
                        </Box>
                    ).reverse()}
                </div>
            </div>

            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => handleDeleteTeam()}
                onReject={() => { }}
            >
                <h2>Delete Our Team</h2>
                <p>Are you sure you want to Delete this Team?</p>

            </DeleteConformation>
        </>
    )
}

export default MeetOurTeam